import { createContext, useState, useEffect } from 'react';
import api from '../services/api';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      try {
        const payload = JSON.parse(atob(storedToken.split('.')[1]));
        api.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
        return { 
          id: payload.userId, 
          role: payload.role, 
          storeId: payload.storeId,
          permissions: payload.permissions 
        };
      } catch (e) {
        return null;
      }
    }
    return null;
  });

  useEffect(() => {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser({ 
          id: payload.userId, 
          role: payload.role, 
          storeId: payload.storeId,
          permissions: payload.permissions 
        });
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } catch (e) {
        setUser(null);
      }
    } else {
      setUser(null);
      delete api.defaults.headers.common['Authorization'];
    }
  }, [token]);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    if (res.data.require2FA) {
      return res.data; // Return { require2FA: true, userId }
    }
    localStorage.setItem('token', res.data.token);
    setToken(res.data.token);
    return res.data;
  };

  const verify2FA = async (userId, code) => {
    const res = await api.post('/auth/login/verify', { userId, code });
    localStorage.setItem('token', res.data.token);
    setToken(res.data.token);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, verify2FA, logout }}>
      {children}
    </AuthContext.Provider>
  );
}